module.exports = __webpack_public_path__ + "img/reject-icon.c008db83.svg";